import * as React from 'react';
import Box from '@mui/material/Box';

export default class Bs4ReportCalendarView {  

  ViewComponent = React.forwardRef((props, ref) => {
  
    console.log('...Bs4ReportCalendarView..', props)

    return (
      <Box id='Box_Bs4ReportCalendarView'>
        {/* <Typography>{'Unknown calendar view: '+props.bs4Calendar.viewType}</Typography>        
        <Typography>{'date: '+toDateTime(props.bs4Calendar.date)}</Typography>
        <Typography>{'start: '+toDateTime(props.bs4Calendar.start)}</Typography>
        <Typography>{'end: '+toDateTime(props.bs4Calendar.end)}</Typography> */}
     </Box>
    );        
  });
}